export default __webpack_public_path__ + "static/media/cluster_point_nightsky.9848b746.svg";